export default function GiftSection() {
  return (
    <section className="relative px-4 sm:px-6 lg:px-8 py-20 sm:py-32 lg:py-40 overflow-hidden">
      {/* Radial gradient background */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at center, rgba(168,85,247,0.15) 0%, transparent 70%)',
        }}
      />

      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 px-2">
          <span className="bg-gradient-to-r from-[#00d4ff] via-[#a855f7] to-[#ffd700] bg-clip-text text-transparent">
            Ваш бонус за 2025
          </span>
        </h2>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl md:text-2xl text-white/70 mb-12 sm:mb-16 px-4">
          Спасибо, что были в Roblox весь этот год.
        </p>

        {/* Gift Amount */}
        <div className="mb-8 sm:mb-10 relative">
          <div 
            className="inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-6 animate-float"
            style={{
              filter: 'drop-shadow(0 0 60px rgba(255,215,0,0.4))',
            }}
          >
            <span className="text-6xl sm:text-7xl lg:text-8xl">🎁</span>
            <span className="text-6xl sm:text-7xl lg:text-9xl font-black bg-gradient-to-r from-[#ffd700] to-[#ffed4e] bg-clip-text text-transparent">
              2026
            </span>
          </div>
          <p className="text-2xl sm:text-3xl font-bold text-[#ffd700] mt-3 sm:mt-4">
            Робуксов
          </p>
        </div>

        {/* Description */}
        <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-lg mx-auto mb-10 sm:mb-12 leading-relaxed px-4">
          Получите 2026 Робуксов и начните 2026 год ещё ярче.
        </p>

        {/* CTA Button */}
        <a
          href="https://t.me/vipok98"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 sm:gap-3 px-8 sm:px-10 lg:px-12 py-4 sm:py-5 bg-gradient-to-r from-[#ffd700] to-[#ffed4e] rounded-full text-base sm:text-lg lg:text-xl font-bold text-[#0a0e27] hover:scale-105 hover:shadow-[0_12px_48px_rgba(255,215,0,0.5)] transition-all duration-300 whitespace-nowrap cursor-pointer mx-4"
          style={{
            animation: 'pulse-glow 2s ease-in-out infinite',
          }}
        >
          <span>Получить 2026 Робуксов</span>
          <i className="ri-telegram-line text-xl sm:text-2xl w-5 sm:w-6 h-5 sm:h-6 flex items-center justify-center"></i>
        </a>

        {/* Bot Link */}
        <p className="mt-4 sm:mt-5 text-xs sm:text-sm text-white/50 hover:text-[#00d4ff] transition-colors duration-300 px-4">
          <a href="https://t.me/vipok98" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
            t.me/vipok98
          </a>
        </p>
      </div>

      {/* Decorative elements */}
      <div className="hidden sm:block absolute top-20 left-10 w-3 h-3 bg-[#ffd700] rounded-full animate-pulse" style={{ boxShadow: '0 0 30px #ffd700' }} />
      <div className="hidden sm:block absolute top-40 right-20 w-3 h-3 bg-[#00d4ff] rounded-full animate-pulse" style={{ animationDelay: '0.5s', boxShadow: '0 0 30px #00d4ff' }} />
      <div className="hidden sm:block absolute bottom-40 left-32 w-3 h-3 bg-[#a855f7] rounded-full animate-pulse" style={{ animationDelay: '1s', boxShadow: '0 0 30px #a855f7' }} />
      <div className="hidden sm:block absolute bottom-20 right-40 w-3 h-3 bg-[#ffd700] rounded-full animate-pulse" style={{ animationDelay: '1.5s', boxShadow: '0 0 30px #ffd700' }} />
    </section>
  );
}
